import React from 'react';
import { COOWN_SUPPORT_EMAIL } from '../../config/constants';
import { LEGAL_PAGES } from '../../config/legalPages';
import { scrollPageToTop, scrollToListingsAnchor, scrollToCoownFaq } from '../../utils/properties';

const FOOTER_LINK_STYLE = { color: "rgba(255,255,255,0.7)", textDecoration: "none", fontSize: "0.9rem", cursor: "pointer" };

const Footer = ({ setPage }) => {
  const goPage = (page, after) => (e) => {
    e.preventDefault();
    setPage?.(page, after ? { scrollAfter: after } : {});
  };
  return (
  <footer style={{background:"var(--text)",color:"white",marginTop:"4rem",padding:"3rem 2rem 1.5rem"}}>
    <div className="container" style={{maxWidth:"1400px"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4, 1fr)",gap:"2rem",marginBottom:"2rem"}}>
        <div>
          <div className="logo brand-logo brand-logo--footer" style={{marginBottom:"1rem"}}>
            <img src="/coown-logo-mark.svg" alt="" className="brand-logo-mark" width="36" height="36" />
            <span className="brand-logo-name">CoOwn</span>
          </div>
          <p style={{color:"rgba(255,255,255,0.7)",fontSize:"0.9rem",lineHeight:1.7,marginBottom:"1.5rem"}}>
            Democratizing real estate investing. Pool resources with others to own premium properties and build wealth together.
          </p>
          <div style={{display:"flex",gap:"1rem"}}>
            <a href="#" style={{width:"36px",height:"36px",borderRadius:"50%",background:"rgba(255,255,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",color:"white",textDecoration:"none"}}><i className="fab fa-twitter"></i></a>
            <a href="#" style={{width:"36px",height:"36px",borderRadius:"50%",background:"rgba(255,255,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",color:"white",textDecoration:"none"}}><i className="fab fa-linkedin-in"></i></a>
            <a href="#" style={{width:"36px",height:"36px",borderRadius:"50%",background:"rgba(255,255,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",color:"white",textDecoration:"none"}}><i className="fab fa-instagram"></i></a>
            <a href="#" style={{width:"36px",height:"36px",borderRadius:"50%",background:"rgba(255,255,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",color:"white",textDecoration:"none"}}><i className="fab fa-youtube"></i></a>
          </div>
        </div>
        <div>
          <h4 style={{fontSize:"1rem",fontWeight:700,marginBottom:"1.2rem"}}>Quick Links</h4>
          <ul style={{listStyle:"none",lineHeight:2.2}}>
            <li><a href="/" style={FOOTER_LINK_STYLE} onClick={goPage("home", scrollToListingsAnchor)}>Browse Properties</a></li>
            <li><a href="/marketplace" style={FOOTER_LINK_STYLE} onClick={goPage("marketplace")}>Secondary Marketplace</a></li>
            <li><a href="/calculator" style={FOOTER_LINK_STYLE} onClick={goPage("calculator")}>Investment Calculator</a></li>
            <li><a href="/news" style={FOOTER_LINK_STYLE} onClick={goPage("news")}>Market Insights</a></li>
            <li><a href="/how-it-works" style={FOOTER_LINK_STYLE} onClick={goPage("how-it-works")}>How It Works</a></li>
            <li><a href="/how-it-works#faq" style={FOOTER_LINK_STYLE} onClick={goPage("how-it-works", scrollToCoownFaq)}>FAQ</a></li>
          </ul>
        </div>
        <div>
          <h4 style={{fontSize:"1rem",fontWeight:700,marginBottom:"1.2rem"}}>Legal</h4>
          <ul style={{listStyle:"none",lineHeight:2.2}}>
            {LEGAL_PAGES.map((p) => (
              <li key={p.slug}>
                <a href={p.path} style={FOOTER_LINK_STYLE} onClick={goPage(p.pageKey)}>{p.title}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 style={{fontSize:"1rem",fontWeight:700,marginBottom:"1.2rem"}}>Contact Us</h4>
          <ul style={{listStyle:"none",lineHeight:2.2,color:"rgba(255,255,255,0.7)",fontSize:"0.9rem"}}>
            <li><i className="fas fa-envelope" style={{width:"20px",color:"var(--accent)"}}></i> {COOWN_SUPPORT_EMAIL}</li>
            <li><i className="fas fa-phone" style={{width:"20px",color:"var(--accent)"}}></i> (555) 123-4567</li>
            <li><i className="fas fa-map-marker-alt" style={{width:"20px",color:"var(--accent)"}}></i> 350 Mission St, Suite 200<br/>San Francisco, CA 94105</li>
          </ul>
          <h4 style={{fontSize:"1rem",fontWeight:700,marginTop:"1.5rem",marginBottom:"0.8rem"}}>Stay Updated</h4>
          <div style={{display:"flex",gap:"0.5rem"}}>
            <input type="email" placeholder="Your email" style={{flex:1,padding:"0.6rem 1rem",borderRadius:"8px",border:"none",fontFamily:"inherit",fontSize:"0.9rem"}} />
            <button className="btn btn-accent" style={{padding:"0.6rem 1rem"}}><i className="fas fa-paper-plane"></i></button>
          </div>
        </div>
      </div>
      <div style={{borderTop:"1px solid rgba(255,255,255,0.1)",paddingTop:"1.5rem",marginBottom:"1.5rem"}}>
        <p style={{color:"rgba(255,255,255,0.5)",fontSize:"0.8rem",lineHeight:1.6,textAlign:"center"}}>
          <strong style={{color:"rgba(255,255,255,0.7)"}}>Important Disclosures:</strong> CoOwn does not provide investment advice. All investments involve risk, including the possible loss of principal. Past performance is not indicative of future results. CoOwn is a funding portal registered with the SEC and a member of FINRA.
        </p>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"1rem",borderTop:"1px solid rgba(255,255,255,0.1)",paddingTop:"1.5rem"}}>
        <p style={{color:"rgba(255,255,255,0.5)",fontSize:"0.85rem"}}>
          &copy; {new Date().getFullYear()} CoOwn Real Estate, Inc. All rights reserved.
        </p>
        <div style={{display:"flex",gap:"1.5rem"}}>
          <span style={{color:"rgba(255,255,255,0.5)",fontSize:"0.8rem"}}><i className="fas fa-shield-alt" style={{color:"var(--success)",marginRight:"0.3rem"}}></i> SEC Registered</span>
          <span style={{color:"rgba(255,255,255,0.5)",fontSize:"0.8rem"}}><i className="fas fa-lock" style={{color:"var(--success)",marginRight:"0.3rem"}}></i> 256-bit SSL</span>
          <span style={{color:"rgba(255,255,255,0.5)",fontSize:"0.8rem"}}><i className="fas fa-check-circle" style={{color:"var(--success)",marginRight:"0.3rem"}}></i> FINRA Member</span>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
